import { ConfirmDialog } from '@/components/ui/ConfirmDialog';

/**
 * What Remove does, in the words agreed for it (P33, backend D41): the page
 * leaves the app, and an ARC that lists it keeps it, shown as Removed.
 */
export const REMOVE_WORDS =
  'It will no longer show in the app. If it is in your ARC, it stays listed there as Removed until you take it out.';

interface RemovePageDialogProps {
  /** The page's title, or null when the question is not asked. */
  title: string | null;
  /** The removal is in flight: both answers wait. */
  pending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * The question before Remove (P11, P33). It sends nothing itself: the list
 * sends the one move to ARCHIVED, and never a change to the ARC (B8).
 */
export function RemovePageDialog({
  title,
  pending,
  onConfirm,
  onCancel,
}: RemovePageDialogProps) {
  return (
    <ConfirmDialog
      open={title !== null}
      title={`Remove “${title ?? ''}”?`}
      description={REMOVE_WORDS}
      confirmLabel="Remove"
      destructive
      pending={pending}
      onConfirm={onConfirm}
      onCancel={onCancel}
      testId="pages-remove-dialog"
    />
  );
}
